module.exports = __webpack_public_path__ + "img/smart.dafc0465.jpg";